export default "/images/aros.avif?fc31ec9ce4d774b8a17d0ed7c50059be";